<template>
    <!--弹窗-->
    <el-dialog v-if="visible" width="900px" :title="title" :visible.sync="visible" :before-close="handleClose">
        <div v-loading="loading" :id="'highcharts-ara' + charts_id" style="min-height: 400px;"></div>
        <el-divider></el-divider>
        <div class="phrase-stats">
            <div>
                最高排名:
                <div class="stat-top-info" v-if="min_num != null">
                    <span>{{ min_num }}</span>
                    <span>( {{ min_date }} )</span>
                </div>
                <span v-else> - </span>
            </div>
            <div>
                最低排名:
                <div class="stat-top-info" v-if="max_num != null">
                    <span>{{ max_num }}</span>
                    <span>( {{ max_date }} )</span>
                </div>
                <span v-else> - </span>
            </div>
        </div>
    </el-dialog>
</template>
<script>
    import * as api from '@/api/Product/Product.js'
    import * as Highcharts from 'highcharts'
    import * as loadExporting from 'highcharts/modules/exporting'
    import * as exportExcel from 'highcharts/modules/export-data.src'

    loadExporting(Highcharts)
    exportExcel(Highcharts)
    export default {
        data() {
            return {
                loading: false,
                max_num: null,
                max_date: null,
                min_num: null,
                min_date: null,
                country_code: null,
            }
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            charts_id: {
                type: String,
                default: '0'
            },
            charts_keyword: {
                type: String,
                default: ''
            }
        },
        methods: {
            //最小值
            math_Max_Min(date, rank) {
                let max_num = rank[0]
                let max_date = date[0]
                let min_num = rank[0]
                let min_date = date[0]
                for (let i = 1; i < rank.length; i++) {
                    if (rank[i] != null) {
                        if (rank[i] > max_num || max_num == null) {
                            max_num = rank[i]
                            max_date = date[i]
                        }
                        if (min_num == null || min_num > rank[i]) {
                            min_num = rank[i]
                            min_date = date[i]
                        }
                    }
                }
                this.max_num = max_num
                this.max_date = max_date
                this.min_num = min_num
                this.min_date = min_date
            },
            getList(keyword, country_code) {
                if (country_code) {
                    this.country_code = country_code
                }
                this.loading = true
                let temp = country_code
                for(const item of this.$common.us_arr_normal) {
                    if (item.us == country_code) {
                        temp = item.value
                        break
                    }
                }
                api.ara_index_trend_batch({
                    search_word_list: [keyword],
                    amazon_site: temp
                }).then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        let res_date = res.data[keyword]
                        let dates = []
                        let datas = []
                        for (let i = 0; i < res_date.month.length; i++) {
                            let str = res_date.year[i] + '-' + res_date.month[i]
                            dates.push(str)
                            datas.push(res_date.search_rank[i] == null || res_date.search_rank[i] == 0 ? null : res_date.search_rank[i])
                        }
                        this.math_Max_Min(dates, datas)
                        this.getCharts(dates, datas)
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                })
                    .catch(() => {
                        this.loading = false
                    })
            },
            getCharts(date, data) {
                Highcharts.chart('highcharts-ara' + this.charts_id, {
                    chart: {
                        type: 'line'
                    },
                    title: {
                        text: null
                    },
                    yAxis: {
                        reversed: true,
                        min: 0,
                        title: {
                            text: null
                        }
                    },
                    xAxis: {
                        categories: date,
                        title: {
                            text: 'DateTime'
                        },
                        tickInterval: Math.ceil(date.length / 6),
                        tickWidth: 1
                    },
                    tooltip: {
                        crosshairs: [
                            {
                                width: 1,
                                color: '#ddd'
                            }
                        ],
                        formatter: function () {
                            var s =
                                '<div style=\'font-weight: 900;\'>' +
                                this.x +
                                '</div>'
                            s += '<br/><br/>' + '排名: <b>' + this.y
                            return s
                        }
                    },
                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            label: {
                                connectorAllowed: false
                            },
                            events: {
                                click: function (event) {
                                    // console.log(event.point.options);
                                    console.log(event.point)
                                }
                            }
                        }
                    },
                    legend: {
                        enabled: false
                    },
                    credits: {enabled: false},
                    series: [{data: data, name: '排名'}],
                    responsive: {
                        rules: [
                            {
                                condition: {
                                    maxWidth: 500
                                },
                                chartOptions: {
                                    legend: {
                                        layout: 'horizontal',
                                        align: 'center',
                                        verticalAlign: 'bottom'
                                    }
                                }
                            }
                        ]
                    },
                    exporting: {
                        filename: `${this.title} (数据统计图)`,
                        menuItemDefinitions: {
                            printChart: {
                                text: '打印图表'
                            },
                            downloadJPEG: {
                                text: '下载JPEG 图片'
                            },
                            downloadPDF: {
                                text: '下载PDF 文档'
                            },
                            downloadPNG: {
                                text: '下载PNG 图片'
                            },
                            downloadSVG: {
                                text: '下载SVG 矢量图'
                            },
                            exportButtonTitle: {
                                text: '导出图片'
                            },
                            downloadCSV: {
                                text: '下载CSV 数据表'
                            },
                            downloadXLS: {
                                text: '下载XLS 数据表'
                            }
                        },
                        buttons: {
                            contextButton: {
                                menuItems: [
                                    'printChart',
                                    'separator',
                                    'downloadJPEG',
                                    'downloadPDF',
                                    'downloadPNG',
                                    'downloadSVG',
                                    'separator',
                                    'downloadCSV',
                                    'downloadXLS'
                                ]
                            }
                        }
                    }
                })
            },
            // 关闭弹窗
            handleClose() {
                this.max_num = null
                this.max_date = null
                this.min_num = null
                this.min_date = null
                this.loading = false
                this.$emit('close-callback', true)
            }
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .chart-datepicker {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        margin-bottom: 20px;
    }

    .range-option {
        font-size: 13px;
        color: #3a3a3a;
        padding: 0 10px;
        text-decoration: underline;
        cursor: pointer;
    }

    .range-option:hover {
        color: #666;
        text-decoration: none;
    }

    .phrase-stats {
        margin-left: 10px;
        margin-bottom: 10px;

        div {
            line-height: 30px;
            font-weight: 700;
            font-size: 16px;
        }

        span {
            margin-right: 5px;
        }
    }

    .stat-top-info {
        display: inline-block;
    }

    /deep/ .el-dialog__body {
        padding: 10px 20px 20px 20px !important;
    }
</style>
